import { object, array, number } from '@gogame/schemas';

import {
  NETWORKS,
  PLATFORMS,
  APPLICATIONS,
  AFFILIATES,
  OWNERS,
  LABELS,
  CAMPAIGNS,
  PARTNER_CAMPAIGNS,
  AD_SETS,
  COUNTRIES,
  MASTER_CAMPAIGNS,
  SOCIAL_MEDIA_PLATFORMS,
  INFLUENCER_CAMPAIGNS,
} from './constants';

export const validationSchema = object({
  [COUNTRIES]: array(number()),
  [LABELS]: array(number()),
  [NETWORKS]: array(number()),
  [PLATFORMS]: array(number()),
  [APPLICATIONS]: array(number()),
  [AFFILIATES]: array(number()),
  [OWNERS]: array(number()),
  [LABELS]: array(number()),
  [CAMPAIGNS]: array(number()),
  [PARTNER_CAMPAIGNS]: array(number()),
  [AD_SETS]: array(number()),
  [MASTER_CAMPAIGNS]: array(number()),
  [SOCIAL_MEDIA_PLATFORMS]: array(number()),
  [INFLUENCER_CAMPAIGNS]: array(number()),
});
